/* CG time fix (Oct 12 2026).
   Checkmate silently drops Shopify orders that have no usable pickup time.
   The checkout "When do you want it?" sheet sent ASAP with an empty Pickup Time ISO,
   which wiped the time the menu scheduler had set. This fills a real Pacific timestamp
   (now + 15 min for ASAP), adds the offset to scheduled times, and keeps the
   Requested Time / Order Timing fields consistent so tickets never read "ASAP" and
   "10:07" at once. */
(function () {
  if (window.__cgTimeFix) return; window.__cgTimeFix = true;
  var ASAP_MIN = 15; /* Oct 12 2026: matches Checkmate default prep time */
  function offLA(ms) {
    try {
      var z = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Los_Angeles', timeZoneName: 'shortOffset' })
        .formatToParts(new Date(ms)).filter(function (x) { return x.type === 'timeZoneName'; })[0].value;
      var m = z.match(/([+-])(\d{1,2})(?::(\d{2}))?/);
      if (m) return m[1] + ('0' + m[2]).slice(-2) + ':' + (m[3] || '00');
    } catch (e) {}
    return '-07:00';
  }
  function isoLA(ms) {
    var p = {};
    new Intl.DateTimeFormat('en-US', { timeZone: 'America/Los_Angeles', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
      .formatToParts(new Date(ms)).forEach(function (x) { p[x.type] = x.value; });
    return p.year + '-' + p.month + '-' + p.day + 'T' + p.hour + ':' + p.minute + ':00' + offLA(ms);
  }
  function fix(a) {
    if (!a || typeof a !== 'object' || !('Pickup Time ISO' in a || 'Pickup Time' in a)) return a;
    var iso = a['Pickup Time ISO'], pt = a['Pickup Time'];
    if (pt === 'ASAP' || ((!iso) && (a['Order Timing'] === 'ASAP' || a['Requested Time'] === 'ASAP'))) {
      a['Pickup Time ISO'] = isoLA(Date.now() + ASAP_MIN * 60000);
      a['Requested Time'] = 'ASAP'; a['Order Timing'] = 'ASAP';
      a['Scheduled Date'] = ''; a['Scheduled Time'] = '';
    } else if (iso && /^\d{4}-\d\d-\d\dT\d\d:\d\d(:\d\d)?$/.test(iso)) {
      var p = iso.split(/[-T:]/);
      a['Pickup Time ISO'] = (iso.length === 16 ? iso + ':00' : iso) + offLA(Date.UTC(+p[0], +p[1] - 1, +p[2], +p[3] + 8, +p[4]));
      if (pt && pt !== 'ASAP') { a['Requested Time'] = pt; a['Order Timing'] = 'Scheduled'; }
    }
    /* Oct 12 2026: Checkmate drops any order carrying a "Pickup Time" attribute (every failed order had
       "Pickup Time: ASAP"; CGW#3733 without it injected fine). The time lives in Pickup Time ISO, so an
       empty value removes the key from the cart. */
    if ('Pickup Time' in a) a['Pickup Time'] = '';
    /* only the restaurant checkout sheet omits these keys; catering scripts send their own */
    if (!('Catering Order' in a) && !/cater/i.test((a['Channel'] || '') + (a['Order Type'] || ''))) { a['Catering Order'] = 'No'; a['Headcount'] = ''; }
    return a;
  }
  /* Restaurant hours (Pacific). Mirrors cg_ordering_rules 'restaurant': open 8 AM, close 8 PM Sun-Thu, 9 PM Fri-Sat,
     ordering_cutoff_minutes 0, so ASAP is allowed right up to close. */
  var CUTOFF_MIN = 0; function H() { return window.CG_HOURS || { open: [7, 7, 7, 7, 7, 7, 7], close: [20, 21, 21, 21, 21, 21, 21] }; } /* R71: live hours from cg-core (cg_ordering_rules metaobject) */
  function nowLA() {
    var p = {};
    new Intl.DateTimeFormat('en-US', { timeZone: 'America/Los_Angeles', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' })
      .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    var dow = new Date(Date.UTC(+p.year, +p.month - 1, +p.day)).getUTCDay();
    return { min: (+p.hour) * 60 + (+p.minute), open: H().open[dow] * 60, close: H().close[dow] * 60 };
  }
  function asapOpen() { var n = nowLA(); return n.min >= n.open && n.min <= n.close - CUTOFF_MIN; }

  /* Old checkout sheet (cg-core): label says 15 min, and ASAP stays available until close instead of 30 min before. */
  function relabel() {
    var b = document.querySelector('#cgoc-sheet [data-when="asap"]');
    if (!b) return;
    var sm = b.querySelector('small');
    if (asapOpen() && b.disabled) { b.disabled = false; }
    if (sm && !b.disabled && !/about 15 min$/.test(sm.textContent)) sm.textContent = 'Ready in about ' + ASAP_MIN + ' min';
  }
  document.addEventListener('DOMContentLoaded', function () {
    relabel();
    var sh = document.getElementById('cgoc-sheet');
    if (sh && window.MutationObserver) new MutationObserver(relabel).observe(sh, { attributes: true, attributeFilter: ['hidden', 'disabled'], childList: true, subtree: true });
  });

  /* One time picker, not two: when the menu-page scheduler is on the page and has a choice,
     save its choice to the cart and go straight to checkout instead of asking again. */
  var CHECKOUT = '[name="checkout"],a[href="/checkout"],a[href$="/checkout"],#checkout,#CartDrawer-Checkout';
  function val(id) { var el = document.getElementById(id); return el ? el.value : ''; }
  window.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest(CHECKOUT);
    if (!b || !document.getElementById('cg-attr-timing')) return;
    var timing = val('cg-attr-timing') || 'ASAP', req = val('cg-attr-req'), iso = val('cg-attr-iso');
    if (timing === 'Scheduled' && !iso) return; /* nothing picked yet: let the normal flow ask */
    if (timing !== 'Scheduled' && !asapOpen()) return; /* kitchen closed: let the sheet offer a scheduled time */
    e.preventDefault(); e.stopImmediatePropagation();
    var a = { 'Order Type': val('cg-attr-type') || 'Pickup', 'Channel': 'restaurant', 'Order Timing': timing, 'Requested Time': timing === 'Scheduled' ? req : 'ASAP',
      'Pickup Time': '', 'Pickup Time ISO': timing === 'Scheduled' ? iso : '',
      'Scheduled Date': val('cg-attr-date'), 'Scheduled Time': val('cg-attr-time'), 'Delivery Zip': val('cg-attr-zip') };
    try { sessionStorage.setItem('cg_time_ok', '1'); } catch (x) {}
    window.fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ attributes: a }) })
      .then(function () { location.href = '/checkout'; }, function () { location.href = '/checkout'; });
  }, true);


  /* Native mode: any leftover Toast ordering link (theme settings, late-injected buttons, clicks before
     the page scripts finish) opens our own menu instead. Gift cards, reservations and catering quotes are untouched. */
  function isNative() { return document.documentElement.classList.contains('cg-native') || !!(window.CG_ENHANCE && window.CG_ENHANCE.native); }
  window.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('a[href]');
    if (!a || !isNative()) return;
    var h = a.hostname || '', p = (a.pathname || '').toLowerCase();
    var toast = h === 'order.californiagrill.com' || (/(^|\.)toasttab\.com$/.test(h) && h.indexOf('booking') !== 0 && /california-grill/.test(p) && !/giftcard|reward|invoice|catering/.test(p));
    if (!toast) return;
    e.preventDefault(); e.stopImmediatePropagation();
    location.href = /catering/.test(p) ? '/collections/catering' : '/pages/food-menu-new';
  }, true);

  /* Oct 12 2026: Toast has these as one item with a required modifier group, Shopify sells them as
     variants. Send the variant as that Toast group too, so Checkmate gets e.g. Soft Drinks + Size: Medium 20oz. */
  var VAR_GROUP = {
    42786862301343: ['Size', 'Small'], 62890874405023: ['Size', 'Large'],
    42455933354143: ['Size', 'Large 20oz'], 62890874437791: ['Size', 'Extra Large 32oz'],
    42786850111647: ['Size', 'Medium 20oz'], 62890874372255: ['Size', 'Xtra Large 32oz'],
    42455933517983: ['Size', 'Large'], 62890874470559: ['Size', 'Xtra Large'],
    42786863546527: ['Milkshake Options', 'Chocolate'], 42786863579295: ['Milkshake Options', 'Strawberry'],
    42786863612063: ['Milkshake Options', 'Vanilla'], 42786863644831: ['Milkshake Options', 'Oreo']
  };
  function tagItem(it) {
    var g = it && VAR_GROUP[+it.id]; if (!g) return it;
    it.properties = it.properties || {}; if (!it.properties[g[0]]) it.properties[g[0]] = g[1];
    return it;
  }

  var of = window.fetch;
  if (!of) return;
  window.fetch = function (url, opts) {
    try {
      var u = typeof url === 'string' ? url : (url && url.url) || '';
      if (/\/cart\/update(\.js)?(\?|$)/.test(u) && opts && typeof opts.body === 'string') {
        var b = JSON.parse(opts.body);
        if (b && b.attributes) { b.attributes = fix(b.attributes); opts = Object.assign({}, opts, { body: JSON.stringify(b) }); }
      } else if (/\/cart\/add(\.js)?(\?|$)/.test(u) && opts && typeof opts.body === 'string' && opts.body.charAt(0) === '{') {
        var ab = JSON.parse(opts.body);
        if (ab.items) ab.items = ab.items.map(tagItem); else if (ab.id) tagItem(ab);
        opts = Object.assign({}, opts, { body: JSON.stringify(ab) });
      }
    } catch (e) {}
    return of.apply(this, [url, opts]);
  };
  window.CGTimeFix = { isoLA: isoLA, fix: fix, asapOpen: asapOpen };
})();

/* One pop-up (Oct 12 2026): pickup or delivery and ASAP or a scheduled time are picked right inside the
   "Your order" review panel on the menu page, and Check out goes straight to checkout. No second
   "When do you want it?" sheet. Reads and writes the same order setup the menu script uses (CGMenu.setup()). */
(function () {
  if (window.__cgOnePop) return; window.__cgOnePop = true;
  var C = window.CGM_CONFIG; if (!C) return;
  var TZ = C.timeZone || 'America/Los_Angeles', PREP = C.prepMinutes || 15, PAUSED = !!C.asapPaused;
  var HOURS = C.hours || {}, HOL = C.holidays || [], LOAD = C.loadTable || [];
  var CUT = C.cutoffMinutes || 0, SLOT = C.slotMinutes || 15, MAXD = C.maxDaysAhead || 7, LEAD = C.leadMinutes || PREP;
  var ZONES = (C.zones || []).filter(function (z) { return z.active !== false; });
  var DMIN = C.deliveryMinimum || 0, PMIN = C.pickupMinimum || 0, KEY = 'cgm_setup_v1';
  var DAYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'], DAYN = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(c) { return '$' + (c / 100).toFixed(2); }
  function la() {
    var o = {}; new Intl.DateTimeFormat('en-US', { timeZone: TZ, hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', weekday: 'short' })
      .formatToParts(new Date()).forEach(function (x) { o[x.type] = x.value; });
    var h = +o.hour; if (h === 24) h = 0;
    return { y: +o.year, m: +o.month, d: +o.day, h: h, mi: +o.minute, dow: DAYS.indexOf(o.weekday.toLowerCase().slice(0, 3)) };
  }
  function key(p) { return p.y + '-' + pad(p.m) + '-' + pad(p.d); }
  function addD(p, n) { var d = new Date(Date.UTC(p.y, p.m - 1, p.d + n)); return { y: d.getUTCFullYear(), m: d.getUTCMonth() + 1, d: d.getUTCDate(), dow: d.getUTCDay() }; }
  function hm(s) { var a = String(s || '').split(':'); return (+a[0] || 0) * 60 + (+a[1] || 0); }
  function win(p) {
    var k = key(p), ov = null; HOL.forEach(function (h) { if (h && h.date === k) ov = h; });
    if (ov) return (!ov.open || !ov.close) ? { closed: true } : { open: hm(ov.open), close: hm(ov.close) };
    var h = HOURS[DAYS[p.dow]]; if (!h || !h[0] || !h[1]) return { closed: true };
    return { open: hm(h[0]), close: hm(h[1]) };
  }
  function extra(p, m) { var a = 0; LOAD.forEach(function (r) { if (r && r.days && r.days.indexOf(DAYS[p.dow]) > -1 && m >= hm(r.from) && m < hm(r.to)) a = Math.max(a, +r.add_minutes || 0); }); return a; }
  function ft(m) { var h = Math.floor(m / 60) % 24, mm = m % 60, ap = h >= 12 ? 'PM' : 'AM'; h = h % 12 || 12; return h + ':' + pad(mm) + ' ' + ap; }
  function asap() {
    var p = la(), w = win(p), n = p.h * 60 + p.mi;
    if (PAUSED || w.closed || n < w.open || n > w.close - CUT) return { ok: false };
    return { ok: true, label: ft(n + PREP + extra(p, n)) };
  }
  function slots() {
    var t = la(), out = [];
    for (var i = 0; i <= MAXD; i++) {
      var p = addD(t, i), w = win(p); if (w.closed) continue;
      var first = w.open + Math.max(LEAD, PREP), last = w.close - CUT;
      if (i === 0) first = Math.max(first, Math.ceil((t.h * 60 + t.mi + Math.max(LEAD, PREP)) / SLOT) * SLOT);
      var s = []; for (var m = Math.ceil(first / SLOT) * SLOT; m <= last; m += SLOT) s.push(m);
      if (s.length) out.push({ key: key(p), label: (i === 0 ? 'Today' : i === 1 ? 'Tomorrow' : DAYN[p.dow]) + ', ' + MON[p.m - 1] + ' ' + p.d, slots: s });
    }
    return out;
  }
  function zone(zip) { zip = String(zip || '').replace(/\D/g, '').slice(0, 5); if (zip.length < 5) return null; var hit = null; ZONES.forEach(function (z) { (z.zips || []).forEach(function (pre) { if (!hit && zip.indexOf(String(pre)) === 0) hit = z; }); }); return hit; }
  function S() { return (window.CGMenu && window.CGMenu.setup && window.CGMenu.setup()) || null; }
  var cartSub = 0;
  function valid(s) {
    var ps = document.querySelector('.cgm-panel [data-psub]'); if (ps) cartSub = Math.round(parseFloat((ps.textContent || '0').replace(/[^0-9.]/g, '')) * 100) || 0;
    if (s.when === 'asap') { if (!asap().ok) return 'ASAP is not available right now. Pick a time.'; }
    else { var d = slots().filter(function (x) { return x.key === s.date; })[0]; if (!d || d.slots.indexOf(+s.time) < 0) return 'Pick a day and time.'; }
    if (s.mode === 'delivery') { var z = zone(s.zip); if (!z) return s.zip ? 'We do not deliver to ' + s.zip + ' yet. Pickup is always available.' : 'Enter your delivery zip.'; var mn = z.minimum || DMIN; if (mn && cartSub < mn) return 'Delivery orders are ' + money(mn) + ' minimum.'; }
    else if (PMIN && cartSub < PMIN) return 'Pickup orders are ' + money(PMIN) + ' minimum.';
    return '';
  }
  function normalize(s) {
    var a = asap(), d = slots();
    if (s.when === 'asap' && !a.ok) s.when = 'later';
    if (s.when !== 'asap') { s.when = 'later'; if (!d.filter(function (x) { return x.key === s.date; }).length && d.length) { s.date = d[0].key; s.time = d[0].slots[0]; } var dd = d.filter(function (x) { return x.key === s.date; })[0]; if (dd && dd.slots.indexOf(+s.time) < 0) s.time = dd.slots[0]; }
  }
  function render(box) {
    var s = S(); if (!s) return; normalize(s);
    var a = asap(), d = slots(), later = s.when !== 'asap', del = s.mode === 'delivery', dd = d.filter(function (x) { return x.key === s.date; })[0];
    var h = '<span class="cgm-pw__label">How and when</span>';
    h += '<div class="cgm-pw__seg"><button type="button" data-pw-mode="pickup" aria-pressed="' + !del + '">Pickup</button><button type="button" data-pw-mode="delivery" aria-pressed="' + del + '">Delivery</button></div>';
    h += '<div class="cgm-pw__opt"><button type="button" data-pw-when="asap" aria-pressed="' + !later + '"' + (a.ok ? '' : ' disabled') + '>ASAP<small>' + (a.ok ? 'Ready by ' + a.label : 'Not available now') + '</small></button>';
    h += '<button type="button" data-pw-when="later" aria-pressed="' + later + '">Schedule<small>' + (later && dd ? esc(dd.label) + ', ' + ft(+s.time) : 'Pick a day and time') + '</small></button></div>';
    if (later) h += '<div class="cgm-pw__when"><select data-pw-date aria-label="Day">' + d.map(function (x) { return '<option value="' + x.key + '"' + (x.key === s.date ? ' selected' : '') + '>' + esc(x.label) + '</option>'; }).join('') + '</select><select data-pw-time aria-label="Time">' + (dd ? dd.slots.map(function (t) { return '<option value="' + t + '"' + (t === +s.time ? ' selected' : '') + '>' + ft(t) + '</option>'; }).join('') : '') + '</select></div>';
    if (del) { var z = zone(s.zip); h += '<div class="cgm-pw__zip"><input type="text" inputmode="numeric" maxlength="5" placeholder="Delivery zip" aria-label="Delivery zip" value="' + esc(s.zip || '') + '" data-pw-zip><span class="' + (z ? 'ok' : '') + '">' + (z ? 'We deliver to ' + esc(s.zip) : (String(s.zip || '').length >= 5 ? 'Not in our delivery area yet' : 'Enter your zip')) + '</span></div>'; }
    else h += '<p class="cgm-pw__note">Pickup at 6751 Painter Ave, Whittier. Give your name at the front counter.</p>';
    var why = valid(s); if (why && box.dataset.tried) h += '<p class="cgm-pw__warn">' + esc(why) + '</p>';
    var f = document.activeElement && document.activeElement.hasAttribute && document.activeElement.hasAttribute('data-pw-zip');
    box.innerHTML = h;
    if (f) { var zi = box.querySelector('[data-pw-zip]'); zi.focus(); zi.setSelectionRange(zi.value.length, zi.value.length); }
  }
  var pushT = null;
  function changed(box) {
    var s = S(); if (!s) return; normalize(s);
    try { localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {}
    render(box);
    clearTimeout(pushT);
    pushT = setTimeout(function () {
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: window.CGMenu.attributes() }) })
        .then(function () { return window.CGMenu.loadCart(); }).catch(function () {});
    }, 200);
  }
  function mount() {
    var panel = document.querySelector('.cgm-panel'); if (!panel || panel.__pw) return !!panel;
    panel.__pw = true;
    var lines = panel.querySelector('[data-lines]'); if (!lines) return true;
    var box = document.createElement('div'); box.className = 'cgm-pw'; lines.parentNode.insertBefore(box, lines.nextSibling);
    render(box);
    panel.addEventListener('click', function (e) {
      var m = e.target.closest('[data-pw-mode]'); if (m) { e.stopPropagation(); S().mode = m.getAttribute('data-pw-mode'); changed(box); return; }
      var w = e.target.closest('[data-pw-when]'); if (w) { e.stopPropagation(); if (!w.disabled) { S().when = w.getAttribute('data-pw-when'); changed(box); } }
    }, true);
    panel.addEventListener('change', function (e) {
      var s = S();
      if (e.target.matches('[data-pw-date]')) { s.date = e.target.value; var dd = slots().filter(function (x) { return x.key === s.date; })[0]; s.time = dd ? dd.slots[0] : 0; changed(box); }
      else if (e.target.matches('[data-pw-time]')) { s.time = +e.target.value || 0; changed(box); }
    });
    panel.addEventListener('input', function (e) { if (e.target.matches('[data-pw-zip]')) { var s = S(); s.zip = e.target.value.replace(/\D/g, '').slice(0, 5); if (s.zip.length === 5 || !s.zip) changed(box); } });
    /* repaint whenever the panel opens or the cart changes */
    new MutationObserver(function () { if (!box.contains(document.activeElement)) render(box); }).observe(panel, { attributes: true, attributeFilter: ['class'] });
    /* Check out: save the choice and go straight to checkout */
    window.addEventListener('click', function (e) {
      var co = e.target.closest && e.target.closest('.cgm-panel .cgm-checkout'); if (!co) return;
      e.preventDefault(); e.stopImmediatePropagation();
      var s = S(); normalize(s); var why = valid(s);
      if (why) { box.dataset.tried = '1'; render(box); if (window.CG && window.CG.toast) window.CG.toast(why); box.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      try { localStorage.setItem(KEY, JSON.stringify(s)); sessionStorage.setItem('cg_time_ok', '1'); } catch (x) {}
      co.textContent = 'One sec…';
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: window.CGMenu.attributes() }) })
        .then(function () { location.href = '/checkout'; }, function () { location.href = '/checkout'; });
    }, true);
    return true;
  }
  var css = document.createElement('style');
  css.textContent = '.cgm-panel [data-pwhen]{display:none!important}' +
    '.cgm-pw{margin:18px 0 4px;padding:16px;border-radius:16px;background:#FFF8EC;border:1px solid rgba(27,25,25,.08)}' +
    '.cgm-pw__label{display:block;font:400 22px/1 "Bebas Neue",Impact,"Arial Narrow",Arial,sans-serif;letter-spacing:1px;color:#1B1919;margin:0 0 10px}' +
    '.cgm-pw__seg{display:flex;background:#fff;border:1px solid rgba(27,25,25,.15);border-radius:999px;padding:3px;margin:0 0 10px}' +
    '.cgm-pw__seg button{flex:1;border:0;background:none;border-radius:999px;padding:9px 8px;font:700 14px/1 Lato,Arial,sans-serif;color:#1B1919;cursor:pointer}' +
    '.cgm-pw__seg button[aria-pressed="true"]{background:#1B1919;color:#fff}' +
    '.cgm-pw__opt{display:flex;gap:10px}' +
    '.cgm-pw__opt button{flex:1;padding:13px 10px;border:2px solid #1B1919;border-radius:12px;background:#fff;font:700 15px/1.2 Lato,Arial,sans-serif;color:#1B1919;cursor:pointer;text-align:center}' +
    '.cgm-pw__opt button small{display:block;font-weight:400;font-size:12px;color:#7a7066;margin-top:3px}' +
    '.cgm-pw__opt button[aria-pressed="true"]{background:#1B1919;color:#fff}.cgm-pw__opt button[aria-pressed="true"] small{color:#ddd}' +
    '.cgm-pw__opt button:disabled{opacity:.4;cursor:not-allowed}' +
    '.cgm-pw__when,.cgm-pw__zip{display:flex;gap:10px;align-items:center;margin-top:10px}' +
    '.cgm-pw__when select,.cgm-pw__zip input{flex:1;min-width:0;padding:12px;border:1px solid rgba(27,25,25,.3);border-radius:10px;font:16px Lato,Arial,sans-serif;background:#fff;color:#1B1919}' +
    '.cgm-pw__zip span{font-size:13px;color:#7a7066;flex:1}.cgm-pw__zip span.ok{color:#3f7a1a;font-weight:700}' +
    '.cgm-pw__note{margin:10px 0 0;font-size:13px;color:#7a7066}.cgm-pw__warn{margin:10px 0 0;font-size:13px;color:#b42318;font-weight:700}';
  (document.head || document.documentElement).appendChild(css);
  function tryMount() { if (mount()) return; var n = 0, t = setInterval(function () { if (mount() || ++n > 40) clearInterval(t); }, 250); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tryMount); else tryMount();
})();
